import { createStyles, makeStyles } from "@material-ui/core";
import * as React from "react";

import { baseColors, RelodeTheme, Text } from "../..";
import { SkillJobQualification } from "../../../domain";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            paper: {
                padding: theme.spacing(2),
            },
            noPadding: {
                padding: theme.spacing(0),
                [theme.breakpoints.down("md")]: {
                    padding: theme.spacing(2),
                },
            },
            listItem: {
                padding: theme.spacing(0, 4, 0, 4),
                margin: 0,
                listStyle: "disc",
            },
            header: {
                marginBottom: 15,
            },
            preparingContainer: {
                padding: theme.spacing(3.5, 0),
                backgroundColor: baseColors.cool_gray,
                border: "1px solid",
                borderColor: baseColors.warm_gray,
                width: "220px",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
                alignItems: "center",
                textAlign: "center",
                color: baseColors.light_black,
            },
            preparingWait: {
                display: "flex",
                alignItems: "center",
                gap: "4px",
            },
        }),
    { name: "QualificationView" }
);

export const SkillJobQualificationView = (props: {
    qual: SkillJobQualification;
    isAnyOf: boolean;
}) => {
    const { skills, yearsExperience } = props.qual;
    const classes = useStyles({});

    if (skills.length > 1) {
        return (
            <li>
                <Text variant="body1">
                    {yearsExperience.shortTextPlus} years of experience in{" "}
                    {props.isAnyOf ? "ANY" : "ALL"} of the following:
                </Text>
                <ul className={classes.listItem}>
                    {skills.map((s, i) => (
                        <li key={`skillQualifications-${s.skillTagId}-${i}`}>
                            <Text variant="body1">
                                {!!s.skillTagId
                                    ? s.skillTagName
                                    : s.skillCustomText}
                            </Text>
                        </li>
                    ))}
                </ul>
            </li>
        );
    } else {
        return (
            <li>
                <Text variant="body1">
                    {skills.map(s => (
                        <>
                            {!!s.skillTagId
                                ? s.skillTagName
                                : s.skillCustomText}
                        </>
                    ))}
                    {" (" + yearsExperience.shortTextPlus + " years)"}
                </Text>
            </li>
        );
    }
};
